<script lang="ts">
import FormTooltip from './Tooltip.vue'

export default {
    components: { FormTooltip },
    props: {
        title: { type: String, required: false, default: null },
        textTooltip: { type: String, required: false, default: '' },
        withBordersColor: { type: String, required: false, default: '' },
        hideSection: { type: Boolean, required: false },
        classOverride: { type: String, required: false, default: 'border-opacity-100 mb-4' },
    },
}
</script>

<template>
    <v-sheet
        v-if="!hideSection"
        :border="withBordersColor ? `${withBordersColor} sm` : null"
        :class="withBordersColor ? classOverride : 'pa-2 ma-2'"
    >
        <h2
            v-if="title" class="text-body-1 font-weight-bold"
            :class="withBordersColor && `pa-2 bg-${withBordersColor}`"
        >
            <!-- eslint-disable vue/no-v-html -->
            <span v-html="title" />
            <FormTooltip :text="textTooltip" />
            <slot name="title" />
        </h2>
        <v-divider v-if="!withBordersColor" class="mb-5" />
        <div :class="withBordersColor && 'pa-4 pb-2'">
            <slot />
        </div>
    </v-sheet>
    <div v-else>
        <slot />
    </div>
</template>
